import { render, staticRenderFns } from "./overview-cell-overview-ref.vue?vue&type=template&id=0fb2cf80&scoped=true"
import script from "./overview-cell-overview-ref.vue?vue&type=script&lang=ts"
export * from "./overview-cell-overview-ref.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb2cf80",
  null
  
)

export default component.exports